import { inject, Injectable } from '@angular/core';
import type { FormArray, FormControl } from '@angular/forms';

import { UnassignLocationFacade } from '@recruitee/locations';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class UnassignLocationRequisitionFacade extends UnassignLocationFacade {
  private readonly requisitionFormManager = inject(RequisitionFormManagerService);

  public validateLocations: undefined;

  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
